import React from 'react'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'

export const a: React.FC<{ href: string; children: React.ReactNode }> = ({ children, href }) => (
  <CustomLink
    link_url={{ cached_url: href, id: 'richtext-link', url: '', fieldtype: 'multilink', linktype: '' }}
    is_external={false}
    new_tab={false}
  >
    {children}
  </CustomLink>
)

export const h2: React.FC<{ children: string }> = ({ children }) => (
  <h2 className="text-headingM-mobile laptop:text-headingM font-bold text-text-dark-900">{children}</h2>
)

export const h3: React.FC<{ children: string }> = ({ children }) => (
  <h3 className="text-headingS-mobile laptop:text-headingS font-bold text-text-dark-900">{children}</h3>
)

export const img: React.FC<{ title: string; alt: string; src: string }> = ({ title, alt, src }) => (
  <img src={`${src}/m/1100x0`} alt={alt} title={title} className="w-full" />
)

export default {
  a: { component: a },
  h2: { component: h2 },
  h3: { component: h3 },
  img: { component: img }
}
